module.exports = __webpack_public_path__ + "static/media/dy.59a60d84.svg";